module.exports = __webpack_public_path__ + "static/media/red-check.de170854.svg";